module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic05.cf94ab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic05.png
// module id = 539
// module chunks = 1